<template>
  <Form :model="formData"
        :rules="rules"
        class="forget-password__form"
        ref="form">
    <FormItem prop="password">
      <Input type="password"
             placeholder="请输入密码"
             password
             element-id="password"
             v-model="formData.password" />
    </FormItem>
    <FormItem prop="rePassword">
      <Input type="password"
             placeholder="请再次输入密码"
             password
             element-id="repassword"
             v-model="formData.rePassword" />
    </FormItem>
    <Button @click="handleSubmit"
            long
            :disabled="isSubmitDisabled"
            type="primary"
            :loading="loading"
            shape="circle"
            id="resetPassword">重置密码</Button>
  </Form>
</template>

<script>
import { passwordRecovery } from '@/api/user/user';
import { passwordToMd5 } from '@/utils/util';

export default {
  name: 'step1',
  props: {
    token: String,
  },
  data() {
    return {
      formData: {},
      rules: {
        password: [
          {
            min: 8, required: true, message: '您输入的密码不符合规则，密码长度不能少于8位', trigger: 'blur',
          },
        ],
        rePassword: [
          {
            min: 8, required: true, message: '您输入的密码不符合规则，密码长度不能少于8位', trigger: 'blur',
          },
        ],
      },
      loading: false,
    };
  },
  computed: {
    isSubmitDisabled() {
      const { password = '', rePassword = '' } = this.formData;

      return password.length < 8 || rePassword.length < 8;
    },
  },
  methods: {
    async handleSubmit() {
      if (this.loading) {
        return false;
      }
      const {
        password, rePassword,
      } = this.formData;
      if (password && rePassword && password !== rePassword) {
        this.$Message.error('两次输入的密码不一致，请重新输入');
        return false;
      }
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        const res = await passwordRecovery({
          new_password: passwordToMd5(password),
          token: this.token,
        });
        if (res) {
          this.$emit('on-submit');
        }
        this.loading = false;
      }
      return false;
    },
  },
};
</script>

<style lang="less">

</style>
